// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeUpSkldjourney — "What AI changes in a small business — in numbers."
   Prefix: ai_small_busin_pg_ · no :root variables · no green
   ============================================================ */

.ai_small_busin_pg_section {
  width: 100%;
  padding: 72px 0 80px;
  background: linear-gradient(180deg, #f8f4ff 0%, #f3edff 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
}

.ai_small_busin_pg_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ---------- Header ---------- */

.ai_small_busin_pg_head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 36px;
}

.ai_small_busin_pg_eyebrow {
  margin-bottom: 14px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.ai_small_busin_pg_title {
  max-width: 620px;
  margin: 0 0 14px;
  font-size: clamp(28px, 3.6vw, 44px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.015em;
  color: #0f0a2a;
  text-wrap: balance;
}

.ai_small_busin_pg_subtitle {
  max-width: 540px;
  margin: 0;
  font-size: 15.5px;
  line-height: 1.65;
  color: #5d5978;
}

/* scroll reveal */
.ai_small_busin_pg_eyebrow,
.ai_small_busin_pg_title,
.ai_small_busin_pg_subtitle,
.ai_small_busin_pg_card,
.ai_small_busin_pg_note {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.ai_small_busin_pg_title {
  transition-delay: 0.1s;
}

.ai_small_busin_pg_subtitle {
  transition-delay: 0.2s;
}

.ai_small_busin_pg_card {
  transform: translateY(40px) scale(0.98);
  transition-delay: 0.3s;
}

.ai_small_busin_pg_note {
  transition-delay: 0.6s;
}

.ai_small_busin_pg_in .ai_small_busin_pg_eyebrow,
.ai_small_busin_pg_in .ai_small_busin_pg_title,
.ai_small_busin_pg_in .ai_small_busin_pg_subtitle,
.ai_small_busin_pg_in .ai_small_busin_pg_card,
.ai_small_busin_pg_in .ai_small_busin_pg_note {
  opacity: 1;
  transform: none;
}

/* ---------- Card ---------- */

.ai_small_busin_pg_card {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 22px;
  align-items: start;
  padding: 22px;
  border-radius: 20px;
  border: 1px solid #e4dcf9;
  background: linear-gradient(135deg, #f8f4ff 0%, #fff4ee 100%);
  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.05);
}

/* ---------- List ---------- */

.ai_small_busin_pg_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.ai_small_busin_pg_item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px 10px 12px;
  border: 1px solid #e4dcf9;
  border-radius: 12px;
  background: #ffffff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  color: #1c1538;
  cursor: pointer;
  isolation: isolate;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

/* purple fill that fades + scales in on the active item */
.ai_small_busin_pg_item::before {
  content: "";
  position: absolute;
  inset: -1px;
  z-index: -1;
  border-radius: 12px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  opacity: 0;
  transform: scale(0.94);
  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ai_small_busin_pg_item:hover {
  transform: translateX(4px);
  border-color: #c9b6f2;
  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);
}

.ai_small_busin_pg_item_active,
.ai_small_busin_pg_item_active:hover {
  transform: none;
  border-color: transparent;
  color: #ffffff;
  box-shadow: 0 16px 30px rgba(74, 26, 158, 0.34);
}

.ai_small_busin_pg_item_active::before {
  opacity: 1;
  transform: scale(1);
}

.ai_small_busin_pg_item:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 2px;
}

.ai_small_busin_pg_item_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 9px;
  background: #f0e9ff;
  color: #5a1fb5;
  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ai_small_busin_pg_item_icon svg {
  width: 18px;
  height: 18px;
}

.ai_small_busin_pg_item_active .ai_small_busin_pg_item_icon {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  transform: scale(1.08);
}

.ai_small_busin_pg_item_name {
  flex: 1 1;
  min-width: 0;
  line-height: 1.3;
}

.ai_small_busin_pg_item_value {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 800;
  color: #3a14a0;
  transition: color 0.3s ease;
}

.ai_small_busin_pg_item_active .ai_small_busin_pg_item_value {
  color: #ffbf1f;
}

/* ---------- Detail ---------- */

.ai_small_busin_pg_detail {
  min-width: 0;
  padding: 26px 28px 28px;
  border: 1px solid #e4dcf9;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);
}

/* zoom-out + fade that replays on every click */
.ai_small_busin_pg_panel {
  min-height: 420px;
  transform-origin: 30% 15%;
  animation: ai_small_busin_pg_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes ai_small_busin_pg_zoom {
  from {
    opacity: 0;
    transform: scale(0.9);
    filter: blur(4px);
  }
  to {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

/* each block rises in, one after another */
.ai_small_busin_pg_step {
  animation: ai_small_busin_pg_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--s, 0) * 70ms + 120ms);
}

@keyframes ai_small_busin_pg_rise {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.ai_small_busin_pg_panel_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

.ai_small_busin_pg_panel_label {
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.ai_small_busin_pg_panel_pill {
  padding: 4px 11px;
  border-radius: 999px;
  background: #fdecc2;
  font-size: 11px;
  font-weight: 700;
  color: #6b4a00;
}

.ai_small_busin_pg_figure {
  margin-bottom: 22px;
}

.ai_small_busin_pg_big {
  display: block;
  font-size: clamp(48px, 6.2vw, 80px);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #3a14a0;
  font-variant-numeric: tabular-nums;
  min-height: 1.05em;
  overflow-wrap: anywhere;
}

.ai_small_busin_pg_unit {
  margin: 6px 0 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: #1c1538;
}

/* ---------- Before / after bars ---------- */

.ai_small_busin_pg_bars {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 1px solid #e4dcf9;
  border-radius: 14px;
  background: #ffffff;
}

.ai_small_busin_pg_bar_top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 7px;
  font-size: 12.5px;
}

.ai_small_busin_pg_bar_label {
  min-width: 0;
  color: #3d3858;
}

.ai_small_busin_pg_bar_value {
  flex-shrink: 0;
  font-weight: 800;
  color: #0f0a2a;
}

.ai_small_busin_pg_bar_value_accent {
  color: #4a1a9e;
}

.ai_small_busin_pg_track {
  height: 10px;
  border-radius: 10px;
  background: #f1ebfd;
  overflow: hidden;
}

.ai_small_busin_pg_fill {
  display: block;
  width: var(--w, 0%);
  height: 100%;
  border-radius: 10px;
  background: #d9ccf3;
  /* grows from 0 each time the panel is re-keyed */
  animation: ai_small_busin_pg_grow 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(0.45s + var(--b, 0) * 0.2s);
}

.ai_small_busin_pg_fill_accent {
  background: linear-gradient(90deg, #4a1a9e 0%, #6a1fc2 100%);
}

@keyframes ai_small_busin_pg_grow {
  from {
    width: 0;
  }
}

/* ---------- Text ---------- */

.ai_small_busin_pg_text {
  max-width: 620px;
  margin: 0 0 10px;
  font-size: 14.5px;
  line-height: 1.65;
  color: #1c1538;
}

.ai_small_busin_pg_source {
  margin: 0 0 22px;
  font-size: 11.5px;
  line-height: 1.5;
  color: #6b6784;
}

.ai_small_busin_pg_btn {
  padding: 13px 24px;
  border: 0;
  border-radius: 8px;
  background: #55024f;
  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.ai_small_busin_pg_btn:hover {
  transform: translateY(-3px);
  filter: brightness(1.12);
  box-shadow: 0 14px 28px rgba(85, 2, 79, 0.34);
}

.ai_small_busin_pg_btn:active {
  transform: translateY(0) scale(0.97);
}

.ai_small_busin_pg_btn:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 3px;
}

.ai_small_busin_pg_note {
  margin: 14px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #6b6784;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .ai_small_busin_pg_card {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 18px;
    padding: 18px;
  }

  .ai_small_busin_pg_detail {
    padding: 22px 22px 24px;
  }

  .ai_small_busin_pg_item {
    font-size: 13.5px;
  }
}

/* list becomes a sideways-scrolling row above the detail */
@media (max-width: 820px) {
  .ai_small_busin_pg_section {
    padding: 56px 0 64px;
  }

  .ai_small_busin_pg_card {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .ai_small_busin_pg_list {
    flex-direction: row;
    gap: 8px;
    margin: 0 -4px;
    padding: 4px 4px 10px;
    overflow-x: auto;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .ai_small_busin_pg_list::-webkit-scrollbar {
    display: none;
  }

  .ai_small_busin_pg_item {
    width: auto;
    flex-shrink: 0;
    gap: 10px;
    padding: 9px 14px 9px 10px;
    white-space: nowrap;
    scroll-snap-align: center;
  }

  .ai_small_busin_pg_item:hover {
    transform: none;
  }

  .ai_small_busin_pg_panel {
    min-height: 0;
  }
}

@media (max-width: 560px) {
  .ai_small_busin_pg_container {
    padding: 0 14px;
  }

  .ai_small_busin_pg_head {
    margin-bottom: 26px;
  }

  .ai_small_busin_pg_subtitle {
    font-size: 15px;
  }

  .ai_small_busin_pg_card {
    padding: 12px;
    border-radius: 16px;
  }

  .ai_small_busin_pg_detail {
    padding: 18px 16px 22px;
    border-radius: 14px;
  }

  .ai_small_busin_pg_bars {
    padding: 14px 14px;
  }

  .ai_small_busin_pg_bar_top {
    font-size: 12px;
  }

  .ai_small_busin_pg_btn {
    width: 100%;
    padding: 14px 20px;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .ai_small_busin_pg_eyebrow,
  .ai_small_busin_pg_title,
  .ai_small_busin_pg_subtitle,
  .ai_small_busin_pg_card,
  .ai_small_busin_pg_note,
  .ai_small_busin_pg_item,
  .ai_small_busin_pg_item::before {
    transition: opacity 0.2s ease !important;
    transform: none !important;
  }

  .ai_small_busin_pg_panel,
  .ai_small_busin_pg_step,
  .ai_small_busin_pg_fill {
    animation: ai_small_busin_pg_fade_only 0.25s ease both !important;
    animation-delay: 0s !important;
  }

  @keyframes ai_small_busin_pg_fade_only {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}


/* ---- header tab switch: title block fades in again ---- */
.ai_small_busin_pg_head_swap {
  animation: ai_small_busin_pg_head_swap 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes ai_small_busin_pg_head_swap {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .ai_small_busin_pg_head_swap {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Homeupskldjourney/Homeupskldjourney.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;;;EAKE,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE,UAAU;EACV,eAAe;AACjB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,kFAAkF;AACpF;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,UAAU;EACV,sBAAsB;EACtB,iFAAiF;AACnF;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mGAAmG;AACrG;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;;AAEjC;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,2EAA2E;AAC7E;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE,0EAA0E;EAC1E,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,0EAA0E;EAC1E,iDAAiD;AACnD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,wDAAwD;IACxD,SAAS;IACT,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,SAAS;IACT,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;;;;IAOE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;;;IAGE,iEAAiE;IACjE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;AACF;;;AAGA,4DAA4D;AAC5D;EACE,+EAA+E;AACjF;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomeUpSkldjourney — \"What AI changes in a small business — in numbers.\"\n   Prefix: ai_small_busin_pg_ · no :root variables · no green\n   ============================================================ */\n\n.ai_small_busin_pg_section {\n  width: 100%;\n  padding: 72px 0 80px;\n  background: linear-gradient(180deg, #f8f4ff 0%, #f3edff 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n}\n\n.ai_small_busin_pg_container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ---------- Header ---------- */\n\n.ai_small_busin_pg_head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 36px;\n}\n\n.ai_small_busin_pg_eyebrow {\n  margin-bottom: 14px;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.ai_small_busin_pg_title {\n  max-width: 620px;\n  margin: 0 0 14px;\n  font-size: clamp(28px, 3.6vw, 44px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.015em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.ai_small_busin_pg_subtitle {\n  max-width: 540px;\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.65;\n  color: #5d5978;\n}\n\n/* scroll reveal */\n.ai_small_busin_pg_eyebrow,\n.ai_small_busin_pg_title,\n.ai_small_busin_pg_subtitle,\n.ai_small_busin_pg_card,\n.ai_small_busin_pg_note {\n  opacity: 0;\n  transform: translateY(26px);\n  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.ai_small_busin_pg_title {\n  transition-delay: 0.1s;\n}\n\n.ai_small_busin_pg_subtitle {\n  transition-delay: 0.2s;\n}\n\n.ai_small_busin_pg_card {\n  transform: translateY(40px) scale(0.98);\n  transition-delay: 0.3s;\n}\n\n.ai_small_busin_pg_note {\n  transition-delay: 0.6s;\n}\n\n.ai_small_busin_pg_in .ai_small_busin_pg_eyebrow,\n.ai_small_busin_pg_in .ai_small_busin_pg_title,\n.ai_small_busin_pg_in .ai_small_busin_pg_subtitle,\n.ai_small_busin_pg_in .ai_small_busin_pg_card,\n.ai_small_busin_pg_in .ai_small_busin_pg_note {\n  opacity: 1;\n  transform: none;\n}\n\n/* ---------- Card ---------- */\n\n.ai_small_busin_pg_card {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n  gap: 22px;\n  align-items: start;\n  padding: 22px;\n  border-radius: 20px;\n  border: 1px solid #e4dcf9;\n  background: linear-gradient(135deg, #f8f4ff 0%, #fff4ee 100%);\n  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.05);\n}\n\n/* ---------- List ---------- */\n\n.ai_small_busin_pg_list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.ai_small_busin_pg_item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 16px 10px 12px;\n  border: 1px solid #e4dcf9;\n  border-radius: 12px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n  color: #1c1538;\n  cursor: pointer;\n  isolation: isolate;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n/* purple fill that fades + scales in on the active item */\n.ai_small_busin_pg_item::before {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  z-index: -1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  opacity: 0;\n  transform: scale(0.94);\n  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.ai_small_busin_pg_item:hover {\n  transform: translateX(4px);\n  border-color: #c9b6f2;\n  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);\n}\n\n.ai_small_busin_pg_item_active,\n.ai_small_busin_pg_item_active:hover {\n  transform: none;\n  border-color: transparent;\n  color: #ffffff;\n  box-shadow: 0 16px 30px rgba(74, 26, 158, 0.34);\n}\n\n.ai_small_busin_pg_item_active::before {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.ai_small_busin_pg_item:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 2px;\n}\n\n.ai_small_busin_pg_item_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #f0e9ff;\n  color: #5a1fb5;\n  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.ai_small_busin_pg_item_icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.ai_small_busin_pg_item_active .ai_small_busin_pg_item_icon {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  transform: scale(1.08);\n}\n\n.ai_small_busin_pg_item_name {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.3;\n}\n\n.ai_small_busin_pg_item_value {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 800;\n  color: #3a14a0;\n  transition: color 0.3s ease;\n}\n\n.ai_small_busin_pg_item_active .ai_small_busin_pg_item_value {\n  color: #ffbf1f;\n}\n\n/* ---------- Detail ---------- */\n\n.ai_small_busin_pg_detail {\n  min-width: 0;\n  padding: 26px 28px 28px;\n  border: 1px solid #e4dcf9;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);\n}\n\n/* zoom-out + fade that replays on every click */\n.ai_small_busin_pg_panel {\n  min-height: 420px;\n  transform-origin: 30% 15%;\n  animation: ai_small_busin_pg_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes ai_small_busin_pg_zoom {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n    filter: blur(4px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    filter: blur(0);\n  }\n}\n\n/* each block rises in, one after another */\n.ai_small_busin_pg_step {\n  animation: ai_small_busin_pg_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(var(--s, 0) * 70ms + 120ms);\n}\n\n@keyframes ai_small_busin_pg_rise {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.ai_small_busin_pg_panel_head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.ai_small_busin_pg_panel_label {\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.ai_small_busin_pg_panel_pill {\n  padding: 4px 11px;\n  border-radius: 999px;\n  background: #fdecc2;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b4a00;\n}\n\n.ai_small_busin_pg_figure {\n  margin-bottom: 22px;\n}\n\n.ai_small_busin_pg_big {\n  display: block;\n  font-size: clamp(48px, 6.2vw, 80px);\n  font-weight: 800;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  color: #3a14a0;\n  font-variant-numeric: tabular-nums;\n  min-height: 1.05em;\n  overflow-wrap: anywhere;\n}\n\n.ai_small_busin_pg_unit {\n  margin: 6px 0 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #1c1538;\n}\n\n/* ---------- Before / after bars ---------- */\n\n.ai_small_busin_pg_bars {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 20px;\n  padding: 18px 20px;\n  border: 1px solid #e4dcf9;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.ai_small_busin_pg_bar_top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 7px;\n  font-size: 12.5px;\n}\n\n.ai_small_busin_pg_bar_label {\n  min-width: 0;\n  color: #3d3858;\n}\n\n.ai_small_busin_pg_bar_value {\n  flex-shrink: 0;\n  font-weight: 800;\n  color: #0f0a2a;\n}\n\n.ai_small_busin_pg_bar_value_accent {\n  color: #4a1a9e;\n}\n\n.ai_small_busin_pg_track {\n  height: 10px;\n  border-radius: 10px;\n  background: #f1ebfd;\n  overflow: hidden;\n}\n\n.ai_small_busin_pg_fill {\n  display: block;\n  width: var(--w, 0%);\n  height: 100%;\n  border-radius: 10px;\n  background: #d9ccf3;\n  /* grows from 0 each time the panel is re-keyed */\n  animation: ai_small_busin_pg_grow 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(0.45s + var(--b, 0) * 0.2s);\n}\n\n.ai_small_busin_pg_fill_accent {\n  background: linear-gradient(90deg, #4a1a9e 0%, #6a1fc2 100%);\n}\n\n@keyframes ai_small_busin_pg_grow {\n  from {\n    width: 0;\n  }\n}\n\n/* ---------- Text ---------- */\n\n.ai_small_busin_pg_text {\n  max-width: 620px;\n  margin: 0 0 10px;\n  font-size: 14.5px;\n  line-height: 1.65;\n  color: #1c1538;\n}\n\n.ai_small_busin_pg_source {\n  margin: 0 0 22px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #6b6784;\n}\n\n.ai_small_busin_pg_btn {\n  padding: 13px 24px;\n  border: 0;\n  border-radius: 8px;\n  background: #55024f;\n  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;\n}\n\n.ai_small_busin_pg_btn:hover {\n  transform: translateY(-3px);\n  filter: brightness(1.12);\n  box-shadow: 0 14px 28px rgba(85, 2, 79, 0.34);\n}\n\n.ai_small_busin_pg_btn:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.ai_small_busin_pg_btn:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 3px;\n}\n\n.ai_small_busin_pg_note {\n  margin: 14px 0 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #6b6784;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .ai_small_busin_pg_card {\n    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n    gap: 18px;\n    padding: 18px;\n  }\n\n  .ai_small_busin_pg_detail {\n    padding: 22px 22px 24px;\n  }\n\n  .ai_small_busin_pg_item {\n    font-size: 13.5px;\n  }\n}\n\n/* list becomes a sideways-scrolling row above the detail */\n@media (max-width: 820px) {\n  .ai_small_busin_pg_section {\n    padding: 56px 0 64px;\n  }\n\n  .ai_small_busin_pg_card {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n  }\n\n  .ai_small_busin_pg_list {\n    flex-direction: row;\n    gap: 8px;\n    margin: 0 -4px;\n    padding: 4px 4px 10px;\n    overflow-x: auto;\n    scroll-snap-type: x proximity;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ai_small_busin_pg_list::-webkit-scrollbar {\n    display: none;\n  }\n\n  .ai_small_busin_pg_item {\n    width: auto;\n    flex-shrink: 0;\n    gap: 10px;\n    padding: 9px 14px 9px 10px;\n    white-space: nowrap;\n    scroll-snap-align: center;\n  }\n\n  .ai_small_busin_pg_item:hover {\n    transform: none;\n  }\n\n  .ai_small_busin_pg_panel {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .ai_small_busin_pg_container {\n    padding: 0 14px;\n  }\n\n  .ai_small_busin_pg_head {\n    margin-bottom: 26px;\n  }\n\n  .ai_small_busin_pg_subtitle {\n    font-size: 15px;\n  }\n\n  .ai_small_busin_pg_card {\n    padding: 12px;\n    border-radius: 16px;\n  }\n\n  .ai_small_busin_pg_detail {\n    padding: 18px 16px 22px;\n    border-radius: 14px;\n  }\n\n  .ai_small_busin_pg_bars {\n    padding: 14px 14px;\n  }\n\n  .ai_small_busin_pg_bar_top {\n    font-size: 12px;\n  }\n\n  .ai_small_busin_pg_btn {\n    width: 100%;\n    padding: 14px 20px;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .ai_small_busin_pg_eyebrow,\n  .ai_small_busin_pg_title,\n  .ai_small_busin_pg_subtitle,\n  .ai_small_busin_pg_card,\n  .ai_small_busin_pg_note,\n  .ai_small_busin_pg_item,\n  .ai_small_busin_pg_item::before {\n    transition: opacity 0.2s ease !important;\n    transform: none !important;\n  }\n\n  .ai_small_busin_pg_panel,\n  .ai_small_busin_pg_step,\n  .ai_small_busin_pg_fill {\n    animation: ai_small_busin_pg_fade_only 0.25s ease both !important;\n    animation-delay: 0s !important;\n  }\n\n  @keyframes ai_small_busin_pg_fade_only {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n\n\n/* ---- header tab switch: title block fades in again ---- */\n.ai_small_busin_pg_head_swap {\n  animation: ai_small_busin_pg_head_swap 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes ai_small_busin_pg_head_swap {\n  from { opacity: 0; transform: translateY(14px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ai_small_busin_pg_head_swap {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
